import dcx from "dcx";
import { qs, qsa } from "@fluorescent/dom";

const createSwatchGroup = function (container, group) {
  const { productOption } = group.dataset;
  const swatches = qsa("[data-product-swatch]", group);
  const sel = qs(`select#${productOption}`, container);
  sel.parentElement.style.display = "none";

  const handleClick = evt => {
    evt.preventDefault();
    const swatch = evt.target;
    const classes = [...swatch.classList];
    const { productSwatchOption: selected, label } = swatch.dataset;

    if (
      !classes.includes("product__color-swatch") ||
      classes.includes("selected")
    )
      return;

    // Update swatch color label value
    const optionSelectedLabel = qs(
      "[data-swatch-selected]",
      evt.currentTarget.closest(".product__variant-select")
    );
    if (optionSelectedLabel) optionSelectedLabel.innerHTML = label;

    swatches.forEach(s =>
      dcx(s)({
        selected: s.dataset.productSwatchOption === selected,
      })
    );

    const opt = qs(
      `select#${productOption} [data-value-handle="${selected}"]`,
      container
    );
    opt.selected = true;

    sel.dispatchEvent(new Event("change"));
  };

  group.addEventListener("click", handleClick);

  return () => group.removeEventListener("click", handleClick);
};

export default function (container, groupSelector) {
  const swatchGroups = qsa(groupSelector, container);
  if (swatchGroups.length < 1) return;

  let groups = [];

  swatchGroups.forEach(group =>
    groups.push(createSwatchGroup(container, group))
  );

  return () => groups.forEach(g => g());
}
